<template>
  <mdb-modal  :show="msg.show" @close="$emit('close')" sm>
    <!-- <mdb-modal-header>
      <mdb-modal-title class="sub-title">{{msg.title}}</mdb-modal-title>
    </mdb-modal-header> -->
    <mdb-modal-body style="font-size:15px" class="my-1 py-1">
      <div class="clearfix">
        <div class="float-left">
          <h3>
            <mdb-icon :icon="msg.icon || 'info-circle'" class="mr-3 yellow-text"/>
            <small style="font-size:16px">{{msg.message}}</small>
          </h3>
        </div>
        <div class="float-right text-right">
          <mdb-btn color="white" icon="times" class="p-0" @click="msg.show=false"/>
        </div>
      </div>
      <div class="text-center">
        <mdb-btn class="py-2" @click="msg.show=false">확인</mdb-btn>
      </div>
    </mdb-modal-body>
  </mdb-modal>
</template>
<script>
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
export default {
  name: 'ModalDlg',
  components: { mdbModal, mdbModalBody },
  props: ['msg']
}
</script>
